import { successToast } from "../redux/actions/CommonActions";

export const copyToClipboard = (jobUrl) => {
  navigator.clipboard.writeText(jobUrl);
  successToast("Job link copied successfully.");
};
